import React from "react";
import ReactDom from "react-dom";
import "./index.css";
// import { BrowserRouter } from "react-router-dom";

import App from "./App";

ReactDom.render(<App />, document.getElementById("root"));
